/* unplugin-vue-components disabled */import { render } from "./PreventionGuide.vue?vue&type=template&id=f3e4f958&scoped=true"
import script from "./PreventionGuide.vue?vue&type=script&lang=js"
export * from "./PreventionGuide.vue?vue&type=script&lang=js"

import "./PreventionGuide.vue?vue&type=style&index=0&id=f3e4f958&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e4f958"]])

export default __exports__